import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from './../../../Types/User'; // Adjust the import path as necessary
import { loadClientOptions } from './client';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
};

export const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
      state.isAuthenticated = true;
      // Side effects like dispatching should be handled in a thunk, not in the reducer
    },
    clearUser(state) {
      state.user = null;
      state.isAuthenticated = false;
    },
  },
});

export const { setUser, clearUser } = AuthSlice.actions;

export default AuthSlice.reducer;